// React
import * as React from 'react';

// Redux
import * as actions from './js/actions';
import { connect } from 'react-redux';

import Snackbar from 'material-ui/Snackbar';

class NotificationsProvider extends React.Component {

    render(){
        return (
            <Snackbar
                bodyStyle={{ boxShadow: '1px 1px 10px rgba(0,0,0,0.2)', left: 0, bottom: 0, marginBottom: 0, overflowY: 'hidden' }}
                open={this.props.notificationVisible}
                message={this.props.notificationMessage}
                autoHideDuration={this.props.notificationDuration}
                contentStyle={ styles.notificationStyles(this.props.notificationTextColor) }
            />
        );
    }
};

const mapStateToProps = ({ notification }) => ({
    notificationMessage: notification.message,
    notificationColor: notification.color,
    notificationDuration: notification.duration,
    notificationVisible: notification.visible,
    notificationTextColor: notification.textColor,
});

const styles = {
    notificationStyles: (textColor) => ({
        color: textColor
    })
}

export default connect(mapStateToProps, actions)(NotificationsProvider);



// WEBPACK FOOTER //
// ./src/NotificationsProvider.jsx